import React, { ReactNode, useState, useEffect, useCallback } from 'react';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import "./LoyaltyManagement.css";
import CouponConfigurableLabel from '../manageCoupons/components/CouponConfigurableLabel';
import CustomTable from "../manageCoupons/components/CustomTable";

const SelectedOutletDetails: React.FC<{
    handleRowEdit: (index: number) => void;
    handleRowDelete: (index: number) => void;
    editingRow: boolean;
    tabsList: string[];
    outletBifurcationsList: any[];
    isEditMode: boolean;
}> = ({ handleRowEdit, handleRowDelete, editingRow, tabsList, outletBifurcationsList, isEditMode }) => {
    const [rows, setRows] = useState<Array<Array<string | ReactNode>>>([]);
    const [columns, setColumns] = useState<Array<{ label: string | ReactNode, dataIndex: string, style?: object }>>([]);

    const generateColumns = useCallback(async () => {
        const width = (100 / (tabsList.length + 1)) + '%';
        const col = tabsList.map((item: string) => {
            return {
                label: <CouponConfigurableLabel text={item} style={{ color: 'inherit' }} />,
                dataIndex: item,
                style: { minWidth: '160px', width }
            }
        });
        col.push({
            label: <></>,
            dataIndex: 'action',
            style: { minWidth: '0', width }
        });
        setColumns(col);
    }, [tabsList]);

    const generateRows = useCallback(async () => {
        const rawRows = outletBifurcationsList.map((item: any) =>
            tabsList.map((tab: string) => {
                const fieldValue = item[tab];
                let displayValue = '';

                if (!fieldValue ||
                    (Array.isArray(fieldValue) && fieldValue.length === 0) ||
                    (Array.isArray(fieldValue) && fieldValue.every(val => !val || val.trim() === ''))) {
                    displayValue = 'ALL';
                } else if (Array.isArray(fieldValue)) {
                    displayValue = fieldValue.filter(val => val && val.trim() !== '').join(', ');
                } else {
                    displayValue = fieldValue || 'ALL';
                }
                return displayValue.split("*break*").map((str: string, idx: number) => <span key={idx}>{str}</span>);
            })
        );

        const temp: any = [];
        rawRows.forEach((row: any[], idx: number) => {
            temp.push(
                [
                    ...row.map((element: any, colIdx: number) => {
                        return <div key={`${idx}-${colIdx}`} className={'custom-table-cell'}>{element}</div>
                    }),
                    <div key="actions" className='custom-table-cell-action-btn'>
                        <Button onClick={() => handleRowEdit(idx)} size='small'
                            className='outlet-group-row-selector-edit-button'
                            disabled={isEditMode}
                            startIcon={<DoneIcon />}>
                            Edit
                        </Button>
                        <Button onClick={() => handleRowDelete(idx)} size='small'
                            className='outlet-group-row-selector-delete-button'
                            disabled={isEditMode}
                            startIcon={<DeleteIcon />}>
                            Delete
                        </Button>
                    </div>
                ]
            );
        });
        setRows(temp);
    }, [outletBifurcationsList, tabsList, handleRowEdit, handleRowDelete, isEditMode]);

    const init = useCallback(async () => {
        await generateRows();
        await generateColumns();
    }, [generateRows, generateColumns]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        rows.length > 0 ?
            <CustomTable
                rows={rows}
                columns={columns}
                tableContainerProps={{
                    style: {
                        maxHeight: "350px",
                        border: '0.4px solid #1C7EA0',
                        fontFamily: 'Poppins'
                    }
                }}
                tableProps={{
                    stickyHeader: true
                }}
                tableHeadProps={{}}
                tableHeadCellProps={{
                    style: {
                        color: 'var(--coupon-dark-blue)',
                        padding: "10px 5px",
                        backgroundColor: 'var(--coupon-light-blue)',
                        fontWeight: '600'
                    }
                }}
                tableRowCellProps={{
                    style: { borderBottom: 'none', padding: '16px 5px' },
                    component: "th",
                    scope: "row"
                }}
            />
            :
            <></>
    );
};

export default SelectedOutletDetails